import i18n from "lib/i18n";
import IndicatorButtonView from "views/indicator_button_view";
import Flash from "lib/flash";
import Minpubsub from "minpubsub";
import { track } from "../lib/analytics";
/* eslint-disable
    class-methods-use-this,
    consistent-return,
    constructor-super,
    max-len,
    no-constant-condition,
    no-eval,
    no-multi-assign,
    no-shadow,
    no-this-before-super,
    no-undef,
    no-underscore-dangle,
    no-unused-expressions,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let ContentSubscriptionIndicatorView;

export default ContentSubscriptionIndicatorView = class ContentSubscriptionIndicatorView extends IndicatorButtonView {
  initialize(options) {
    super.initialize(options);
    this._updateView = this._updateView.bind(this);
    this._flashSuccess = this._flashSuccess.bind(this);
    this._flashError = this._flashError.bind(this);
    this._setSubscriptionType = this._setSubscriptionType.bind(this);
    this._getColorForType = this._getColorForType.bind(this);
    this._getLabelForType = this._getLabelForType.bind(this);
    this._getNoticeForType = this._getNoticeForType.bind(this);
    this.contentId = options.contentId;
    this.contentSubscription = options.contentSubscription;

    this._setSubscriptionType("undetermined");

    this.contentSubscription.on("change", this._updateView);
    this.contentSubscription.on("sync", this._flashSuccess);
    this.contentSubscription.on("error", this._flashError);
    this.contentSubscription.fetch();

    Minpubsub.subscribe("comment:created", () => {
      this.contentSubscription.fetch();
      return this._updateView();
    });

    return this.on("click", () => {
      this.contentSubscription.toggle();
      return this._track(this.contentSubscription.get("subscription_type"));
    });
  }

  _updateView() {
    return this._setSubscriptionType(this.contentSubscription.get("subscription_type"));
  }

  _flashSuccess() {
    // don't render a flash notice on the first "change" event
    // this case can be detected if the previous state is "undefined"
    if (this.contentSubscription.previous("subscription_type") != null) {
      const type = this.contentSubscription.get("subscription_type");
      if (this._getNoticeForType(type) != null) { return Flash.now("notice", this._getNoticeForType(type)); }
    }
  }

  _flashError() {
    return Flash.now("notice", this._getNoticeForType("error"));
  }

  _setSubscriptionType(type) {
    this.setTitle(this._getLabelForType(type));
    return this.setColor(this._getColorForType(type));
  }

  // origianlly writen as "content.subscription_type.#{type}.color"
  // but hygiene linter won't pass as it sees unused declarations.

  _getColorForType(type) {
    switch (type) {
      case "subscribed":
        return IndicatorButtonView.GREEN;
      case "suppressed":
        return IndicatorButtonView.RED;
      case "undetermined":
        return IndicatorButtonView.RED;
      default:
        return undefined;
    }
  }

  _getLabelForType(type) {
    switch (type) {
      case "subscribed":
        return i18n.t("content.subscription_type.subscribed.label");
      case "suppressed":
        return i18n.t("content.subscription_type.suppressed.label");
      case "undetermined":
        return i18n.t("content.subscription_type.undetermined.label");
      default:
        return undefined;
    }
  }

  _getNoticeForType(type) {
    switch (type) {
      case "subscribed":
        return i18n.t("content.subscription_type.subscribed.notice");
      case "suppressed":
        return i18n.t("content.subscription_type.suppressed.notice");
      case "error":
        return i18n.t("content.subscription_type.error.notice");
      default:
        return undefined;
    }
  }

  _track(type) {
    track("ContentSubscription", type, "ContentSubscriptionIndicatorView");
  }
};
